{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ProductHuntIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ProductHuntIcon = React.forwardRef<SVGSVGElement, ProductHuntIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 76 123"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M11.8536 69.3332C11.8536 73.665 11.9113 77.8164 11.8384 81.9638C11.761 86.3396 11.6684 110.411 11.3573 114.773C11.2604 116.561 10.7938 118.31 9.98701 119.908C8.36979 122.884 4.65551 122.908 2.89849 120.008C2.17833 118.744 1.74054 117.338 1.61531 115.888C1.27073 112.429 0.913729 89.2484 1.01152 85.783C1.55169 66.5858 2.13118 47.3876 2.91484 28.2002C3.13931 22.7211 4.0464 17.2657 4.75261 11.8135C4.91764 10.2515 5.34291 8.72794 6.01082 7.30631C6.57592 6.19055 7.56899 4.92835 8.66902 4.50567C25.915 -2.11481 42.7297 -0.565187 59.0758 7.58191C64.2926 10.0519 68.6804 13.9824 71.708 18.8967C76.3766 26.6553 76.4849 34.4131 71.458 42.0221C66.9673 48.8191 60.859 53.916 53.7482 57.7549C40.9161 64.6826 27.2565 68.7281 12.5919 69.0523C12.3339 69.1114 12.0854 69.2059 11.8536 69.3332ZM11.6389 58.5532C14.5826 58.1548 17.1299 57.7604 19.6889 57.4722C30.1782 56.2219 40.3314 52.9769 49.6015 47.9121C54.9135 45.1888 59.5519 41.3162 63.1799 36.5758C66.4455 32.2007 66.4219 27.675 63.7285 23.0773C61.6938 19.6053 58.7062 17.0877 55.3241 15.0045C43.5803 7.76247 30.7824 6.27202 17.4206 8.26004C12.2086 9.03517 11.6907 9.76423 11.6527 15.0491C11.5542 28.7317 11.5287 42.4184 11.4854 56.0984C11.4827 56.863 11.5785 57.6304 11.6389 58.5532Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="74.8225" height="122.079" fill={color} transform="translate(0.705811 0.0864258)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

ProductHuntIcon.displayName = 'ProductHuntIcon'
